import MapMarker from "../UI/MapMarker.vue";
import Map from "../UI/Map.vue";
import MarkerContent from "../UI/MarkerContent.vue";

export const searchMapComponents = {
  components: { Map, MapMarker, MarkerContent },
};

export const searchMapInject = {
  inject: ["jobSearchGlobal"],
};

export const searchMapData = {
  data() {
    return {
      hasMapMoved: false,
    };
  },
};

export const searchMapComputed = {
  computed: {
    resolvedMarkers() {
      const coordMap = {};

      this.state.items.forEach((item) => {
        item.coordinate.forEach((coord) => {
          const key = coord.join(",");
          if (!coordMap[key]) {
            coordMap[key] = {
              coordinate: [...coord].reverse(), // safely clone and reverse Typesense lat,lng → lng,lat to match maplibre format
              items: [],
            };
          }

          coordMap[key].items.push(item);
        });
      });

      return Object.values(coordMap);
    },
  },
};

export const searchMapWatch = {
  watch: {
    "state.items": {
      handler(newItems) {
        if (newItems && newItems.length && !this.hasMapMoved) {
          this.centerOnFirstResult();
        }
      },
      immediate: false,
    },
  },
};

export const searchMapMethods = {
  methods: {
    onBoundsChanged(bounds) {
      if (this.state && this.state.refine) {
        this.state.refine(bounds);
      }
    },
    centerOnFirstResult() {
      const first = this.resolvedMarkers[0];
      if (first && first.coordinate && this.$refs.mapRef) {
        this.$refs.mapRef.centerMap(first.coordinate, 8);
      }
    },
    focusOnClickedItem(item) {
      if (this.$refs.mapRef) {
        this.$refs.mapRef.centerMap(item.coordinate);
      }

      this.$emit("marker-clicked", item);
    },
  },
};
